



























import { Component, Vue, Prop } from 'vue-property-decorator'
import BuilderContainer from '@/components/builder/BuilderContainer.vue'
import { mapState } from 'vuex'
import { ProjectIsGPT } from '@/utils/project'

@Component({
  components: { BuilderContainer },
  computed: {
    ...mapState('app', { showMenu: 'showMenu' }),
  },
})
export default class BuilderTwoColumnContainer extends Vue {
  @Prop({ default: false, type: Boolean }) hidden!: boolean
  @Prop({ default: false, type: Boolean }) isGPT!: boolean
  showMenu: any
  onHeaderClick(): void {
    if (this.isGpt) {
      window.location.href = process.env.VUE_APP_API_BASE_URL
    } else {
      window.location.href = '/'
    }
  }

  get isGpt() {
    return ProjectIsGPT()
  }
}
